<template>
<div
    ref="videoContent"
    class="tile__s__video"
    :class="embedClass"
    @click.stop="">
    <Player
        v-if="sources && sources[0]"
        :source="sources"
        :poster="imgUrl" />
    <embed-content
        v-else-if="isEmbed"
        :embed-content="embedContent"
        :embed-poster="embedPoster" />
    <img
        v-else
        :src="imgUrl"
        onerror="this.src=process.env.DEFAULT_IMAGE"
        alt="">
</div>
</template>

<script>
    import Player from "./Player";
    import {mapGetters} from "vuex";
    import EmbedContent from "./EmbedContent";

    export default {
        components: {EmbedContent, Player},
        props: {
            content: {type: Object, default: () => {}},
        },
        computed: {
            ...mapGetters('auth', {
                currentUser: 'getCurrentUser'
            }),
            audio() {
                return this.content.audio
            },
            sources() {
                if (this.content.class_name === 'Product') {
                    return null
                } else {
                    return (this.audio || {}).sources
                }
            },
            poster() {
                return (this.audio || {}).poster
            },
            isEmbed() {
                return (this.content.class_name === 'CardNetwork' && this.content.audio && this.content.audio.source_type === 'url' && !!this.embedContent)
            },
            embedContent() {
                return ((this.audio || {}).embed_url_info || {}).embed_content
            },
            embedClass () {
                return (this.content.embed_url_info || {}).provider_name || ''
            },
            embedPoster() {
                return null
            },
            imgUrl() {
                return this.poster || this.content.cover_photo || this.content.main_image_url || this.content.embed_url_info?.img_src || this.content.logo_image || process.env.DEFAULT_IMAGE
            }
        }
    };
</script>

<style lang="scss">
    .Anchor .embed__content iframe {
        padding-top: 17%;
    }
</style>